import React, { useEffect } from 'react';
import { loadAppResources } from '.';
import ErrorsComponent from '@react_components/errors/lib/Errors';
import MainRouting from './pages/MainRouting';
import ToastsComponent from '@react_components/toasts';
import DialogsComponent from '@react_components/dialog';
import MobileSummaryModal from './views/mobileSummaryModal/MobileSummaryModal';
import './others/fonts/fonts.css';

function App() {
	useEffect(() => {
		loadAppResources();
	}, []);


	return (
		<>
			<MainRouting />
			<MobileSummaryModal />
			<ErrorsComponent />
			<ToastsComponent />
			<DialogsComponent />
		</>
	);
}

export default App;
